import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { filter, take } from 'rxjs/operators';
import { VoucherService } from '../../services/voucher.service';
import { PermissionService } from '../../services/permission.service';
import { UserPermission } from '../../models/permission.model';
import { VoucherInsightsDto } from '../../models/voucher.model';

@Component({
    selector: 'app-voucher-insights',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './voucher-insights.component.html',
    styleUrl: './voucher-insights.component.css'
})
export class VoucherInsightsComponent implements OnInit {
    isLoading: boolean = false;
    errorMessage: string = '';

    // Date Filters
    fromDate?: string;
    toDate?: string;

    // Statistics from New API
    stats: VoucherInsightsDto = {
        totalVouchers: 0,
        totalActiveVouchers: 0,
        totalRedeemedVouchers: 0,
        totalRevokedVouchers: 0,
        totalExpiredVouchers: 0,
        totalCancelledVouchers: 0,
        totalVoucherAmount: 0,
        totalRedeemedAmount: 0,
        totalMinPurchaseAmount: 0
    };

    constructor(
        private voucherService: VoucherService,
        private permissionService: PermissionService
    ) { }

    ngOnInit(): void {
        // Wait for permissions to be loaded before fetching insights
        this.permissionService.permissions$.pipe(
            filter(permissions => permissions.length > 0),
            take(1)
        ).subscribe(() => {
            this.loadInsights();
        });
    }

    /**
     * Load voucher insights using the new dedicated APIs
     */
    loadInsights(): void {
        this.isLoading = true;
        this.errorMessage = '';

        // Determine which API to call based on user permissions
        const insightsObservable = this.permissionService.hasPermission(UserPermission.Partner_ViewVouchers)
            ? this.voucherService.getPartnerInsights(this.fromDate, this.toDate)
            : this.voucherService.getOutletInsights(this.fromDate, this.toDate);

        insightsObservable.subscribe({
            next: (response) => {
                this.stats = response;
                this.isLoading = false;
            },
            error: (error) => {
                console.error('Error loading voucher insights:', error);
                this.errorMessage = 'Failed to load voucher statistics. Please try again.';
                this.isLoading = false;
            }
        });
    }
}
